export default __webpack_public_path__ + "static/media/icon-protective-factor.98fb87f4.svg";